var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.$currentUrl === 'NewMember')?_c('register-member'):_vm._e(),(_vm.$currentUrl === 'Member')?_c('edit-member'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }